<template>
  <div class="modal-wrapper tw-fixed tw-inset-0 tw-grid tw-place-items-center tw-p-4">
    <div
      class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-25"
      @click="close()"
    ></div>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppModal',
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-wrapper {
  z-index: 9999;
}
</style>
